import language_default from "./language_default.js";
import language_rs from "./language_rs.js";
import language_cz from "./language_cz.js";
import language_es from "./language_es.js";
import language_gr from "./language_gr.js";
import language_hr from "./language_hr.js";
import language_hu from "./language_hu.js";
import language_lt from "./language_lt.js";
import language_pl from "./language_pl.js";
import language_ro from "./language_ro.js";
import language_si from "./language_si.js";
import language_sk from "./language_sk.js";
import language_tr from "./language_tr.js";
import language_bg from "./language_bg.js";

export default {
  default: language_default,
  rs: language_rs,
  cz: language_cz,
  es: language_es,
  gr: language_gr,
  hr: language_hr,
  hu: language_hu,
  lt: language_lt,
  pl: language_pl,
  ro: language_ro,
  si: language_si,
  sk: language_sk,
  tr: language_tr,
  bg: language_bg,
};
